import React from 'react';
import BrandContext from './BrandContext';
import isValidBrand from './isValidBrand';

/**
 * Provider to enable context
 *
 * @param single brand string
 * @param children
 * @returns {*}
 * @constructor
 */
import { jsx as _jsx } from "react/jsx-runtime";
export default function BrandProvider({
  brand = '',
  children
}) {
  isValidBrand(brand);
  return /*#__PURE__*/_jsx(BrandContext.Provider, {
    value: brand,
    children: children
  });
}